export default "__VITE_ASSET__DIp1q3$K__"